import React, { useState } from "react";
import {
  Box,
  Divider,
  Avatar,
  Typography,
  TextField,
  FormControlLabel,
  Radio,
  Collapse,
  Grid,
} from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import AddCancelButton from "../../../../components/AddCancelButtons/AddCancelButton";
import MailRoundedIcon from "@material-ui/icons/MailRounded";
import LastModifed from "../../../../components/LastModified/LastModified";
import CandidateRating from "../../../../components/CandidateRating/CandidateRating";
import SearchJob from "../../../../components/SearchJob/SearchJob";
import SearchCompany from "../../../../components/SearchCompany/SearchCompany";
import HighlightOffRoundedIcon from "@material-ui/icons/HighlightOffRounded";
import JobAcceptedQuestionierSummary from "../../../../components/JobAcceptedQuestionierSummary/JobAcceptedQuestionierSummary";
import CandidateInterview from "../../../../components/CandidateInterview/CandidateInterview";
import UnderJobContext from "../../../../context/underJobContext";
import DateFnsUtils from "@date-io/date-fns";
import { MenuMoreOptions } from "../../../../config/candidatesConfigData";
import green from "@material-ui/core/colors/green";
import { RawlIcon } from "../../../../Assets/CustomIcons/CustomIconsList";
import {
  MuiPickersUtilsProvider,
  KeyboardDateTimePicker,
} from "@material-ui/pickers";
import AssignToEntity from "../../../../components/AssignToEntity/AssignToEntity";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    justifyContent: "flex-start",
    flexFlow: "wrap",
    alignItems: "center",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    textOverflow: "ellipsis",
    "& .MuiAvatar-root": {
      marginRight: theme.spacing(2),
      marginLeft: theme.spacing(2),
    },
  },
  success: {
    color: green[500],
  },
  endIcon: {
    marginRight: theme.spacing(1),
    marginLeft: theme.spacing(1),
  },
  buttons: {
    marginTop: theme.spacing(2),
  },
}));

const getIconForEventType = (eventId) => {
  const menuSelectedIndex = MenuMoreOptions.findIndex(
    (menuItem) => menuItem.id === eventId
  );
  if (menuSelectedIndex > -1) {
    return MenuMoreOptions[menuSelectedIndex].icon;
  }
};

const getViewBoxForEventType = (eventId) => {
  const menuSelectedIndex = MenuMoreOptions.findIndex(
    (menuItem) => menuItem.id === eventId
  );
  if (menuSelectedIndex > -1) {
    return MenuMoreOptions[menuSelectedIndex].viewBox;
  }
};

/*
Accepted Props:
eventTitle
eventType = list of eventTypes
authorImage
jobTitle - optional
drafMode - show add / cancel buttons
editable - show edit icon
disableLastModified
columnView - if true, row is displayed in column view
*/

const EventRow = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const [eventValue, setEventValue] = useState("");
  const [currenJob, setCurrentJob] = useState(true);
  const [interviewer, setInterviewer] = useState("");
  const [interviewDate, setInterviewDate] = useState(new Date());
  const [interviewAddress, setInterviewAddress] = useState("");
  const [isEditMode, setIsEditMode] = useState(false);
  const [assignToEventType, setAssignToEventType] = useState("job"); //either job or company
  const additionalInfo = React.useRef(null);

  const handleEditMode = (type) => {
    setIsEditMode(true);
    if (type === "sendToInterview" || type === "companySendToInterview") {
      props.interview.interview_date &&
        setInterviewDate(props.interview.interview_date.toLocaleString());
      setInterviewer(props.interview.interviewer);
      setInterviewAddress(props.interview.interview_address);
    }
  };
  const handleCancelEditMode = () => {
    setIsEditMode(false);
  };
  const displayIconForType = (type) => {
    return (
      <RawlIcon
        color="primary"
        viewBox={getViewBoxForEventType(type)}
        size="small"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d={getIconForEventType(type)}
        />
      </RawlIcon>
    );
  };

  const onCommentChangeHandler = (event) => {
    setEventValue(event.target.value);
  };

  const onRatingChangeHandler = (value) => {
    setEventValue(value);
  };

  //also handle send invite to job
  const handleAddLinkToJob = (id) => {
    setEventValue(id);
  };

  const handleCancelItem = () => {
    props.cancelEvent();
  };
  const displayRowType = () => {
    if (props.draftMode || isEditMode) {
      switch (props.eventType) {
        case "addComment":
          return (
            <div
              style={{
                marginRight: theme.spacing(1),
                flexDirection: "column",
                //flex: 1,
                width: "100%",
                display: "flex",
                paddingLeft: theme.spacing(2),
                paddingRight: theme.spacing(2),
              }}
            >
              <TextField
                id="outlined-multiline-comments"
                label="Add Comment"
                multiline
                rows={3}
                variant="outlined"
                onChange={onCommentChangeHandler}
                value={eventValue}
                //style={{ flex: 1 }}
              />

              <Box
                mt={theme.spacing(1)}
                display="flex"
                alignItems="center"
                justifyContent={props.columnView ? "center" : "flex-start"}
              >
                <AddCancelButton
                  addCaption="Add"
                  cancelCaption="Cancel"
                  addClick={() => props.onAddEvent("addComment", eventValue)}
                  cancelClick={handleCancelItem}
                />
              </Box>
            </div>
          );
        case "cvReferrals":
          return (
            <UnderJobContext.Consumer>
              {(context) => (
                <Box
                  display="flex"
                  flexDirection="column"
                  mr={props.columnView ? 0 : theme.spacing(1)}
                >
                  {context.job ? (
                    <React.Fragment>
                      <FormControlLabel
                        value="currentJob"
                        disabled={isEditMode}
                        checked={currenJob}
                        control={<Radio color="primary" />}
                        label="This Job"
                        onClick={() => setCurrentJob(true)}
                      />
                      <FormControlLabel
                        value="OtherJob"
                        checked={!currenJob}
                        disabled={isEditMode}
                        control={<Radio color="primary" />}
                        label="Different Job"
                        onClick={() => setCurrentJob(false)}
                      />
                    </React.Fragment>
                  ) : null}

                  <Collapse in={context.job ? !currenJob : true}>
                    <SearchJob searchMode linkToJobId={handleAddLinkToJob} />
                  </Collapse>

                  <Box
                    display="flex"
                    justifyContent={props.columnView ? "center" : "flex-start"}
                    mt={theme.spacing(1)}
                  >
                    <AddCancelButton
                      addCaption={"Confirm"}
                      cancelCaption="Cancel"
                      addClick={() => {
                        setIsEditMode(false);
                        props.onAddEvent(
                          "cvReferrals",
                          context.job ? context.job.id : eventValue
                        );
                      }}
                      cancelClick={handleCancelItem}
                    />
                  </Box>
                </Box>
              )}
            </UnderJobContext.Consumer>
          );
        case "recruitmentSucceeded":
        case "companyRecruitmentSucceeded":
          return (
            <UnderJobContext.Consumer>
              {(context) => (
                <React.Fragment>
                  <Box
                    display="flex"
                    flexDirection="column"
                    style={{
                      width: "100%",
                      paddingRight: theme.spacing(2),
                      paddingLeft: theme.spacing(2),
                    }}
                  >
                    {!context.job && (
                      // <Box display={"flex"} alignItems="center" mb={2}>
                      //   <FormControlLabel
                      //     value="job"
                      //     disabled={isEditMode}
                      //     checked={assignToEventType === "job"}
                      //     control={<Radio color="primary" />}
                      //     label="Assign to Job"
                      //     onClick={() => setAssignToEventType("job")}
                      //   />
                      //   <FormControlLabel
                      //     value="company"
                      //     checked={assignToEventType === "company"}
                      //     disabled={isEditMode}
                      //     control={<Radio color="primary" />}
                      //     label="Assign to company"
                      //     onClick={() => setAssignToEventType("company")}
                      //   />
                      // </Box>
                      <AssignToEntity
                        onSelect={(value) => setAssignToEventType(value)}
                        isDisabled={isEditMode}
                        assignTo={assignToEventType}
                      />
                    )}
                    {context.job ? (
                      <React.Fragment>
                        <FormControlLabel
                          value="currentJob"
                          disabled={isEditMode}
                          checked={currenJob}
                          control={<Radio color="primary" />}
                          label="This Job"
                          onClick={() => setCurrentJob(true)}
                        />
                        <FormControlLabel
                          value="OtherJob"
                          checked={!currenJob}
                          disabled={isEditMode}
                          control={<Radio color="primary" />}
                          label="Different Job"
                          onClick={() => setCurrentJob(false)}
                        />
                      </React.Fragment>
                    ) : (
                      <Typography variant="body1">
                        The candidate has been recruited successfully to:
                      </Typography>
                    )}
                    <Collapse in={context.job ? !currenJob : true}>
                      {assignToEventType === "job" ? (
                        <SearchJob
                          searchMode
                          linkToJobId={handleAddLinkToJob}
                        />
                      ) : (
                        <SearchCompany
                          searchMode
                          linkToCompany={handleAddLinkToJob}
                        />
                      )}
                    </Collapse>
                    <Collapse in={eventValue > 0}>
                      <Typography
                        variant="body1"
                        className={classes.success}
                        style={{ marginRight: theme.spacing(1) }}
                      >
                        Candidate recruited successfully
                      </Typography>
                      <Box
                        display="flex"
                        flexDirection="column"
                        mr={props.columnView ? 0 : theme.spacing(1)}
                        mt={theme.spacing(2)}
                      >
                        <TextField
                          id="outlined-multiline-comments"
                          label="Add Comment"
                          multiline
                          rows={3}
                          variant="outlined"
                          inputRef={additionalInfo}
                          style={{ flex: 1 }}
                        />
                      </Box>
                    </Collapse>
                    <Box
                      display="flex"
                      justifyContent={
                        props.columnView ? "center" : "flex-start"
                      }
                      mt={theme.spacing(1)}
                    >
                      <AddCancelButton
                        addCaption="Confirm Recruitment"
                        cancelCaption="Cancel"
                        addClick={() =>
                          assignToEventType === "job"
                            ? props.onAddEvent(
                                "recruitmentSucceeded",
                                context.job && currenJob
                                  ? context.job.id
                                  : eventValue,
                                {
                                  comments: additionalInfo
                                    ? additionalInfo.current.value
                                    : "",
                                }
                              )
                            : props.onAddEvent(
                                "companyRecruitmentSucceeded",
                                eventValue,
                                {
                                  comments: additionalInfo
                                    ? additionalInfo.current.value
                                    : "",
                                }
                              )
                        }
                        cancelClick={handleCancelItem}
                      />
                    </Box>
                  </Box>
                </React.Fragment>
              )}
            </UnderJobContext.Consumer>
          );
        case "sendToInterview":
        case "companySendToInterview":
          return (
            <UnderJobContext.Consumer>
              {(context) => (
                <Box
                  display="flex"
                  flexDirection="column"
                  mr={props.columnView ? 0 : theme.spacing(1)}
                >
                  {!context.job && (
                    <AssignToEntity
                      onSelect={(value) => setAssignToEventType(value)}
                      isDisabled={isEditMode}
                      assignTo={assignToEventType}
                    />
                  )}
                  {context.job ? (
                    <React.Fragment>
                      <FormControlLabel
                        value="currentJob"
                        disabled={isEditMode}
                        checked={currenJob}
                        control={<Radio color="primary" />}
                        label="This Job"
                        onClick={(event) => setCurrentJob(true)}
                      />
                      <FormControlLabel
                        value="OtherJob"
                        checked={!currenJob}
                        disabled={isEditMode}
                        control={<Radio color="primary" />}
                        label="Different Job"
                        onClick={(event) => setCurrentJob(false)}
                      />
                    </React.Fragment>
                  ) : null}

                  <Collapse in={context.job ? !currenJob : true}>
                    {assignToEventType === "job" ? (
                      <SearchJob searchMode linkToJobId={handleAddLinkToJob} />
                    ) : (
                      <SearchCompany
                        searchMode
                        linkToCompany={handleAddLinkToJob}
                      />
                    )}
                  </Collapse>
                  <Grid
                    container
                    style={{ marginTop: theme.spacing(2) }}
                    justify="center"
                    alignContent="center"
                  >
                    <Grid item xs={6}>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDateTimePicker
                          margin="normal"
                          id="date-picker-dialog"
                          label="Interview Date"
                          format="dd/MM/yyyy hh:mm"
                          minutesStep={5}
                          disablePast
                          value={interviewDate}
                          onChange={(date) =>
                            setInterviewDate(date.toLocaleString())
                          }
                          KeyboardButtonProps={{
                            "aria-label": "Select date",
                          }}
                        />
                      </MuiPickersUtilsProvider>
                    </Grid>
                    <Grid item xs={6} style={{ paddingTop: theme.spacing(3) }}>
                      <TextField
                        id="interviewer"
                        label="Interviewer name"
                        value={interviewer}
                        fullWidth
                        onChange={(event) => setInterviewer(event.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12} style={{ marginTop: theme.spacing(1) }}>
                      <TextField
                        id="interviewAddress"
                        label="Interview address"
                        value={interviewAddress}
                        fullWidth
                        onChange={(event) =>
                          setInterviewAddress(event.target.value)
                        }
                      />
                    </Grid>
                  </Grid>

                  <Box
                    display="flex"
                    justifyContent={props.columnView ? "center" : "flex-start"}
                    mt={theme.spacing(1)}
                  >
                    <AddCancelButton
                      addCaption={isEditMode ? "Update" : "Add"}
                      cancelCaption="Cancel"
                      addClick={() => {
                        setIsEditMode(false);
                        assignToEventType === "job"
                          ? props.onAddEvent(
                              "sendToInterview",
                              context.job ? context.job.id : eventValue,
                              {
                                interviewDate: interviewDate.toLocaleString(),
                                interviewer,
                                interviewAddress,
                                eventId: isEditMode ? props.interview.id : -1,
                              },
                              isEditMode
                            )
                          : props.onAddEvent(
                              "companySendToInterview",
                              context.job ? context.job.id : eventValue,
                              {
                                interviewDate: interviewDate.toLocaleString(),
                                interviewer,
                                interviewAddress,
                                eventId: isEditMode ? props.interview.id : -1,
                              },
                              isEditMode
                            );
                      }}
                      cancelClick={
                        isEditMode ? handleCancelEditMode : handleCancelItem
                      }
                    />
                  </Box>
                </Box>
              )}
            </UnderJobContext.Consumer>
          );
        case "job_mail_sent":
        case "sendInvitation":
          return (
            <UnderJobContext.Consumer>
              {(context) => (
                <Box
                  display="flex"
                  flexDirection="column"
                  style={{
                    width: "100%",
                    paddingRight: theme.spacing(2),
                    paddingLeft: theme.spacing(2),
                  }}
                >
                  {context.job ? (
                    <React.Fragment>
                      <FormControlLabel
                        value="currentJob"
                        disabled={isEditMode}
                        checked={currenJob}
                        control={<Radio color="primary" />}
                        label="This Job"
                        onClick={(event) => setCurrentJob(true)}
                      />
                      <FormControlLabel
                        value="OtherJob"
                        checked={!currenJob}
                        disabled={isEditMode}
                        control={<Radio color="primary" />}
                        label="Different Job"
                        onClick={(event) => setCurrentJob(false)}
                      />
                    </React.Fragment>
                  ) : (
                    <Typography variant="body1">
                      Select a job for invitation
                    </Typography>
                  )}
                  <Collapse in={context.job ? !currenJob : true}>
                    <SearchJob searchMode linkToJobId={handleAddLinkToJob} />
                  </Collapse>
                  <Box
                    mt={theme.spacing(1)}
                    display="flex"
                    alignItems="center"
                    justifyContent={props.columnView ? "center" : "flex-start"}
                  >
                    <AddCancelButton
                      addCaption="Send"
                      addIcon={<MailRoundedIcon />}
                      cancelCaption="Cancel"
                      addClick={() =>
                        props.onAddEvent(
                          "sendInvitation",
                          context.job && currenJob ? context.job.id : eventValue
                        )
                      }
                      cancelClick={handleCancelItem}
                    />
                  </Box>
                </Box>
              )}
            </UnderJobContext.Consumer>
          );
        case "sendEmail":
          return (
            <div
              style={{
                marginRight: theme.spacing(1),
                flexDirection: "column",
                flex: 1,
                display: "flex",
              }}
            >
              <div style={{ marginTop: theme.spacing(1) }}>
                <AddCancelButton
                  addCaption="Add"
                  cancelCaption="Cancel"
                  addClick={() => props.onAddEvent("addComment", eventValue)}
                  cancelClick={handleCancelItem}
                />
              </div>
            </div>
          );
        case "addRating":
          return (
            <Box
              display="flex"
              flexDirection="column"
              mr={props.columnView ? 0 : theme.spacing(1)}
            >
              <CandidateRating onRatingChange={onRatingChangeHandler} />

              <Box
                display="flex"
                justifyContent={props.columnView ? "center" : "flex-start"}
                mt={theme.spacing(1)}
              >
                <AddCancelButton
                  addCaption="Add"
                  cancelCaption="Cancel"
                  addClick={() => props.onAddEvent("addRating", eventValue)}
                  cancelClick={handleCancelItem}
                />
              </Box>
            </Box>
          );
        case "unsubscribeRequest": {
          return (
            <Box
              display="flex"
              flexDirection="column"
              mr={props.columnView ? 0 : theme.spacing(1)}
              style={{
                width: "100%",
                paddingRight: theme.spacing(2),
                paddingLeft: theme.spacing(2),
              }}
            >
              <TextField
                id="outlined-multiline-comments"
                label="Reason for unsubscribe:"
                multiline
                rows={3}
                variant="outlined"
                onChange={onCommentChangeHandler}
                value={eventValue}
                fullWidth
              />

              <Box
                display="flex"
                justifyContent={props.columnView ? "center" : "flex-start"}
                mt={theme.spacing(1)}
              >
                <AddCancelButton
                  addCaption="Add"
                  cancelCaption="Cancel"
                  addClick={() =>
                    props.onAddEvent("unsubscribeRequest", eventValue)
                  }
                  cancelClick={handleCancelItem}
                />
              </Box>
            </Box>
          );
        }
        case "link_to_job": {
          //return create a search text to add job id or external job id with a button to view all jobs
          return (
            <div
              style={{
                marginRight: theme.spacing(1),
                flexDirection: "column",
                flex: 1,
                display: "flex",
              }}
            >
              <SearchJob searchMode linkToJobId={handleAddLinkToJob} />
              <Box
                mt={theme.spacing(1)}
                display="flex"
                alignItems="center"
                justifyContent={props.columnView ? "center" : "flex-start"}
              >
                <AddCancelButton
                  addCaption="Add"
                  cancelCaption="Cancel"
                  addClick={() => props.onAddEvent("link_to_job", eventValue)}
                  cancelClick={handleCancelItem}
                />
              </Box>
            </div>
          );
        }
        case "removeFromJob": {
          return (
            <UnderJobContext.Consumer>
              {(context) => (
                <div
                  style={{
                    marginRight: theme.spacing(1),
                    flexDirection: "column",
                    flex: 1,
                    display: "flex",
                  }}
                >
                  {context.job ? (
                    <React.Fragment>
                      <FormControlLabel
                        value="currentJob"
                        checked={currenJob}
                        control={<Radio color="primary" />}
                        label="This Job"
                        onClick={(event) => setCurrentJob(true)}
                      />
                      <FormControlLabel
                        value="OtherJob"
                        checked={!currenJob}
                        control={<Radio color="primary" />}
                        label="Different Job"
                        onClick={(event) => setCurrentJob(false)}
                      />
                    </React.Fragment>
                  ) : null}
                  <Collapse in={context.job ? !currenJob : true}>
                    <SearchJob searchMode linkToJobId={handleAddLinkToJob} />
                  </Collapse>
                  <Box
                    mt={theme.spacing(1)}
                    display="flex"
                    alignItems="center"
                    justifyContent={props.columnView ? "center" : "flex-start"}
                  >
                    <AddCancelButton
                      addCaption="Remove job link"
                      addIcon={<HighlightOffRoundedIcon />}
                      cancelCaption="Cancel"
                      addClick={() =>
                        props.onAddEvent(
                          "removeFromJob",
                          currenJob ? context.job.id : eventValue
                        )
                      }
                      cancelClick={handleCancelItem}
                    />
                  </Box>
                </div>
              )}
            </UnderJobContext.Consumer>
          );
        }
        // case "addReminder":
        //   return <ScheduleRoundedIcon style={{ color: grey[500] }} />;
        case "addPhoneInterview":
          return (
            <UnderJobContext.Consumer>
              {(context) => (
                <Box
                  display="flex"
                  flexDirection="column"
                  justifyContent="center"
                  mr={props.columnView ? 0 : theme.spacing(1)}
                >
                  {context.job ? (
                    <React.Fragment>
                      <FormControlLabel
                        value="currentJob"
                        disabled={isEditMode}
                        checked={currenJob}
                        control={<Radio color="primary" />}
                        label="This Job"
                        onClick={(event) => setCurrentJob(true)}
                      />
                      <FormControlLabel
                        value="OtherJob"
                        checked={!currenJob}
                        disabled={isEditMode}
                        control={<Radio color="primary" />}
                        label="Different Job"
                        onClick={(event) => setCurrentJob(false)}
                      />
                    </React.Fragment>
                  ) : null}

                  <Collapse in={context.job ? !currenJob : true}>
                    <SearchJob searchMode linkToJobId={handleAddLinkToJob} />
                  </Collapse>
                  <TextField
                    id="outlined-multiline-comments"
                    label="Phone interview summary:"
                    multiline
                    rows={3}
                    variant="outlined"
                    onChange={onCommentChangeHandler}
                    value={eventValue}
                    style={{ marginTop: theme.spacing(1) }}
                  />
                  <Box
                    mt={theme.spacing(1)}
                    display="flex"
                    alignItems="center"
                    justifyContent={props.columnView ? "center" : "flex-start"}
                  >
                    <AddCancelButton
                      addCaption={isEditMode ? "Update" : "Add"}
                      cancelCaption="Cancel"
                      addClick={() => {
                        setIsEditMode(false);
                        props.onAddEvent(
                          "addPhoneInterview",
                          context.job.id,
                          eventValue
                        );
                      }}
                      cancelClick={
                        isEditMode ? handleCancelEditMode : handleCancelItem
                      }
                    />
                  </Box>
                </Box>
              )}
            </UnderJobContext.Consumer>
          );
        case "advancedRecruitmentProcedures":
          return (
            <UnderJobContext.Consumer>
              {(context) => (
                <Box
                  display="flex"
                  flexDirection="column"
                  mr={props.columnView ? 0 : theme.spacing(1)}
                  style={{
                    width: "100%",
                    paddingRight: theme.spacing(2),
                    paddingLeft: theme.spacing(2),
                  }}
                >
                  <TextField
                    id="outlined-multiline-comments"
                    label="Comment for advanced recruitment procedures"
                    multiline
                    rows={3}
                    variant="outlined"
                    onChange={onCommentChangeHandler}
                    value={eventValue}
                    style={{ flex: 1 }}
                  />

                  <Box
                    display="flex"
                    justifyContent={props.columnView ? "center" : "flex-start"}
                    mt={theme.spacing(1)}
                  >
                    <AddCancelButton
                      addCaption="Add"
                      cancelCaption="Cancel"
                      addClick={() =>
                        props.onAddEvent(
                          "advancedRecruitmentProcedures",
                          context.job.id,
                          eventValue
                        )
                      }
                      cancelClick={handleCancelItem}
                    />
                  </Box>
                </Box>
              )}
            </UnderJobContext.Consumer>
          );
        default:
          //default: link to job
          return (
            <div style={{ display: "flex", justifyContent: "flex-start" }}>
              <Typography variant="body1">{props.eventTitle}</Typography>
              <Typography
                variant="body1"
                style={{ fontWeight: 600, marginRight: theme.spacing(1) }}
              >
                {props.jobTitle ? props.jobTitle : ""}
              </Typography>
              {props.disableLastModified ? null : (
                <LastModifed toDate={props.event.event_date} />
              )}
            </div>
          );
      }
    } else {
      return (
        <React.Fragment>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
            }}
          >
            <Typography
              variant="body1"
              className={
                props.event.event_key === "recruitmentSucceeded" ||
                props.event.event_key === "companyRecruitmentSucceeded"
                  ? classes.success
                  : ""
              }
            >
              {props.eventTitle ? props.eventTitle : props.event.event_value}
            </Typography>
            <div
              className={`${classes.endIcon} ${
                props.event.event_key === "recruitmentSucceeded" ||
                props.event.event_key === "companyRecruitmentSucceeded"
                  ? classes.success
                  : ""
              }`}
            >
              {props.endIcon ? props.endIcon : null}
            </div>

            <Typography
              variant="body1"
              style={{ fontWeight: 600, marginRight: theme.spacing(1) }}
            >
              {props.eventTitle ? props.jobTitle : ""}
            </Typography>
            {props.eventType === "addRating" ? (
              <CandidateRating ratingValue={props.event.event_value} />
            ) : null}
            {props.disableLastModified ? null : (
              <LastModifed toDate={props.event.event_date} />
            )}
          </div>

          {props.eventType === "candidate_accepted_job" ? (
            <JobAcceptedQuestionierSummary
              candidateId={props.event.event_candidate_id}
              jobId={props.event.job_id}
            />
          ) : null}

          {props.eventType === "sendToInterview" ||
          props.eventType === "companySendToInterview" ? (
            <CandidateInterview
              interview={props.interview}
              editEvent={() => handleEditMode("sendToInterview")}
            />
          ) : null}
          {props.eventType === "advancedRecruitmentProcedures" ||
          props.eventType === "addPhoneInterview" ? (
            <div>
              <Typography variant="body1">
                <strong>Additional Info:</strong> {props.event.event_value}
              </Typography>
            </div>
          ) : null}
          {props.eventType === "recruitmentSucceeded" ||
          props.event.event_key === "companyRecruitmentSucceeded" ? (
            <div>
              <Typography variant="body1">
                <strong>Additional Info:</strong> {props.event.event_value}
              </Typography>
            </div>
          ) : null}
        </React.Fragment>
      );
    }
  };

  return (
    <React.Fragment>
      <Box
        display="flex"
        justifyContent="flex-start"
        alignItems="center"
        flexDirection={props.columnView ? "column" : "row"}
      >
        <div className={classes.root}>
          {displayIconForType(
            props.eventType ? props.eventType : props.event.event_key
          )}
          <Avatar
            alt=""
            src={props.authorImage ? props.authorImage : undefined}
            className={classes.large}
          />
        </div>
        {displayRowType()}
      </Box>
      {!props.draftMode && !props.isEditMode && (
        <Box my={theme.spacing(2)}>
          <Divider />
        </Box>
      )}
    </React.Fragment>
  );
};
export default EventRow;
